// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"136":"1130fe09","491":"696a582f","782":"c662db13"}[chunkId] + ".chunk.css";
};